import { Button, Input, Table } from 'antd';
import { useUnit } from 'effector-react';
import {
  $usersLog,
  $usersLogsTableProps,
  changeUsersLogTableEv,
  getUsersLogFx,
  UsersLogGate,
} from '../../models/adminSecurityModel/index.js';
import dayjs from 'dayjs';
import { useState } from 'react';

const initSearch = {
  object_type: null,
  object_id: null,
  audit_action: null,
  ip_address: null,
  endpoint: null,
  user_id: null,
};

export default function UsersLog() {
  const { data, count } = useUnit($usersLog);
  const loading = useUnit(getUsersLogFx.pending);

  const [search, setSearch] = useState(initSearch);

  const table = useUnit($usersLogsTableProps);
  const changeTable = useUnit(changeUsersLogTableEv);

  const columns = [
    { dataIndex: 'id', title: 'ID' },
    { dataIndex: 'user_id', title: 'ID пользователя' },
    { dataIndex: 'object_type', title: 'Тип объекта' },
    { dataIndex: 'object_id', title: 'ID объекта' },
    { dataIndex: 'action', title: 'Действие' },
    { dataIndex: 'endpoint', title: 'Эндпоинт' },
    { dataIndex: 'ip_address', title: 'IP-адрес' },
    {
      dataIndex: 'event_datetime',
      title: 'Дата и время',
      render: (d) => dayjs(d).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <>
      <div className={'grid-3 mb-16'}>
        <Input
          onChange={(e) =>
            setSearch((prev) => ({ ...prev, user_id: e.target.value }))
          }
          value={search.user_id}
          placeholder={'ID пользователя'}
        />
        <Input
          onChange={(e) =>
            setSearch((prev) => ({ ...prev, object_id: e.target.value }))
          }
          value={search.object_id}
          placeholder={'ID объекта'}
        />
        <Input
          onChange={(e) =>
            setSearch((prev) => ({ ...prev, object_type: e.target.value }))
          }
          value={search.object_type}
          placeholder={'Тип объекта'}
        />
        <Input
          onChange={(e) =>
            setSearch((prev) => ({ ...prev, audit_action: e.target.value }))
          }
          value={search.audit_action}
          placeholder={'Действие'}
        />
        <Input
          onChange={(e) =>
            setSearch((prev) => ({ ...prev, ip_address: e.target.value }))
          }
          value={search.ip_address}
          placeholder={'IP адрес'}
        />
        <div className={'flex-16'}>
          <Button
            onClick={() => changeTable({ ...search, page: 1, limit: 10 })}
          >
            Поиск
          </Button>
          <Button
            danger
            onClick={() => {
              setSearch(initSearch);
              changeTable({ ...initSearch, page: 1, limit: 10 });
            }}
          >
            Сбросить
          </Button>
        </div>
      </div>
      <UsersLogGate />
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          onChange: (curPage, pageSize) => {
            changeTable({
              page: curPage,
              limit: pageSize,
            });
          },
          total: count,
          current: table.page,
          pageSize: table.limit,
        }}
      />
    </>
  );
}
